import React from "react";

/**
 * StatusBadge — business status pill. Mirrors mobile StatusBadge.tsx.
 * Statuses: on_track | waiting_customer | waiting_dno | delayed | complete | on_hold
 */
const CONFIG = {
    on_track:         { label: "On Track",             bg: "#E6F1DE", fg: "#2E7E22", dot: "#2E7E22" },
    waiting_customer: { label: "Waiting for Customer", bg: "#FEF3C7", fg: "#92400E", dot: "#B45309" },
    waiting_dno:      { label: "Waiting for DNO",      bg: "#FEEDE5", fg: "#B45309", dot: "#F26522" },
    delayed:          { label: "Delayed",              bg: "#FEE2E2", fg: "#991B1B", dot: "#DC2626" },
    complete:         { label: "Complete",             bg: "#DBEAFE", fg: "#1E40AF", dot: "#2563EB" },
    on_hold:          { label: "On Hold",              bg: "#E5E7EB", fg: "#374151", dot: "#6B7280" },
};

export default function StatusBadge({ status = "on_track", size = "md", testid }) {
    const cfg = CONFIG[status] || CONFIG.on_track;
    const small = size === "sm";
    return (
        <span
            data-testid={testid}
            className={`inline-flex items-center gap-1.5 rounded-full font-medium ${small ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs"}`}
            style={{ background: cfg.bg, color: cfg.fg }}
        >
            <span className="rounded-full" style={{ background: cfg.dot, width: small ? 5 : 6, height: small ? 5 : 6 }} />
            {cfg.label}
        </span>
    );
}
